/*
<summary>
   This enum defines the tool_master.inspection_status values.
   Developer: Aashish Singh, Created Date: 25-Aug-2026
</summary>
*/
enum InspectionStatusEnum {
  Inspected = 0,
  NotInspected = 1
}

export default InspectionStatusEnum;
